module.exports = __webpack_public_path__ + "assets/img/Back_cover.09dc261d-ps.jpg";